import SidebarLayout from "@/layouts/SidebarLayout.vue"

import { Layouts, SharedLayoutComponent } from "./Layout.shared"

export { Layouts } from "./Layout.shared"

export const LayoutComponent = {
  ...SharedLayoutComponent,
  [Layouts.SIDEBAR]: SidebarLayout,
}
